import templateUrl from './tax-notice-dashboard.component.html';

export const TaxNoticeDashboardComponent = {
    templateUrl,
    controller: TaxNoticeDashboardController,
    controllerAs: "vm",
};

function TaxNoticeDashboardController(taxNoticeService, employeeService, utilityService) {
    'ngInject';
    const vm = this;
    vm.isManager = false;
    vm.isHJEE = false;

    vm.$onInit = function () {
        utilityService.showLoading();

        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                taxNoticeService.getUserRole(result.UserName)
                    .then(function (usrRole) {
                        console.log(usrRole);
                        if (usrRole === "HJEE" || usrRole === "Manager") {
                            vm.isManager = true;
                            vm.isHJEE = true;
                        }
                        utilityService.hideLoading();
                    })
                return result;
            })
            .catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            })
    };
}
